export const getNativeConfig = () => {
  return {
    native: {
      allowNavigation: ['*.sdui.dev', '*.sdux.de', 'connect.pupil.ch', 'iam.sdui-group.app'],
      appName: 'PUPIL Connect',
      packageName: 'ch.pupil.connect',
      defaultUrl: 'https://connect.pupil.ch',
      android: {
        flavor: 'pupil'
      },
      ios: {
        Scheme: 'PUPIL'
      }
    }
  }
}
